<template>
  <v-container fluid class="pa-0">
    <div class="leads-management-filter">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="d-flex flex-wrap ga-3 pa-0 mt-2 align-center">
          <Input v-model="search" type="search" placeholder="Search here..." />
          <button @click="handleInput" class="cancel-btn" style="width: auto">
            <img :src="SearchIcon" alt="search" />
          </button>
          <AdvancedFilter :store="store" />
        </v-col>

        <v-col
          cols="12"
          :md="6"
          :sm="6"
          class="d-flex flex-wrap ga-2 pa-0 align-center justify-start"
        >
          <!-- <v-menu v-if="menu.length > 0" transition="slide-y-transition">
            <template v-slot:activator="{ props }">
              <v-btn
                :disabled="selected_rows.length === 0"
                class="create-menu-btn d-flex align-center ga-2"
                variant="text"
                v-bind="props"
              >
                <span class="fs-14">Create</span>
               
              </v-btn>
            </template>
            <v-list class="create-list">
              <v-list-item v-for="(item, i) in menu" :key="i">
                <v-list-item-title @click="createItem(item)">
                  <span class="fs-14">{{ item }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->

          <v-menu v-if="assign_to_account_menu" transition="slide-x-transition">
            <template v-slot:activator="{ props }">
              <v-btn
               :disabled="!hasWritePermission"
                class="create-menu-btn assign add-to-account-list"
                variant="text"
                v-bind="props"
              >
                <div class="fs-14 d-flex align-center ga-2">
                  <!-- Icon SVG omitted -->
                  <span>Assign to Account</span>
                  <!-- Arrow SVG omitted -->
                </div>
              </v-btn>
            </template>
            <v-list class="create-list fs-14">
              <v-list-item
                v-for="(item, i) in [
                  'Assign To New Account',
                  'Assign To Existed Account',
                ]"
                :key="i"
              >
                <v-list-item-title @click="assignToAccount(item)">{{
                  item
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col
          cols="12"
          :sm="6"
          :md="6"
          class="d-flex flex-wrap ga-2 align-center justify-end"
        >
          <button
            :disabled="!hasWritePermission"
            :class="{ 'disabled-module': !hasWritePermission }"
            @click="OpenNewDialog(parent)"
            class="d-flex align-center ga-3 dashoard-btn"
          >
            <!-- Add Icon SVG -->
            <span class="fs-14 text-capitalize">Add New {{ parent }}</span>
          </button>

          <button
            :disabled="!hasWritePermission"
             :class="{ 'disabled-module': !hasWritePermission }"
            @click="$router.push({ name: dashboard_path_name })"
            class="d-flex align-center ga-3 dashoard-btn"
          >
            <!-- Dashboard Icon SVG -->
            <span>Dashboard</span>
          </button>
        </v-col>

        <v-col
          v-if="hidden_headers.length > 0"
          cols="12"
          :sm="6"
          :md="6"
          class="d-flex flex-wrap ga-2 align-center justify-end filed-autocomplete"
        >
          <div v-if="hidden_headers.length > 0">
            <v-btn
              id="show-hidden-columns-3"
              variant="text"
              class="show-hidden-columns pa-0 text-subtitle-1 text-none px-2"
            >
              <div class="fs-14 d-flex align-center ga-2">
                <!-- Eye SVG Icon -->
                <span>Show hidden columns</span>
                <!-- Arrow SVG -->
              </div>
            </v-btn>
            <v-menu activator="#show-hidden-columns-3">
              <v-list>
                <v-list-item
                  v-for="(item, index) in hidden_headers"
                  :key="index"
                  :value="index"
                >
                  <v-list-item-title
                    class="d-flex align-center ga-2"
                    @click="showHiddenColumn(item.key)"
                  >
                    <!-- Eye Icon -->
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>

      <!-- Dialog Components -->
      <NewAccount
        :dialog="NewAccountDialog"
        @update:dialog="updateAccountDialog"
        :contacts="selected_rows"
      />
      <NewContact
        :dialog="NewContactDialog"
        @update:dialog="updateContactDialog"
      />
      <AssignToAccount
        :dialog="AssignToAccountDialog"
        @update:dialog="updateAssignToAccountDialog"
        :contacts="selected_rows"
      />
      <NewProject
        :dialog="NewProjectDialog"
        @update:dialog="updateNewProjectDialog"
        :contacts="selected_rows"
      />
      <NewEvent
        :contacts="selected_rows"
        :dialog="NewEventDialog"
        @update:dialog="updateNewEventDialog"
      />
      <NewDeal
        :contacts="selected_rows"
        :dialog="NewDealDialog"
        @update:dialog="updateNewDealDialog"
      />
      <NewTask
        :contacts="selected_rows"
        :dialog="NewTaskDialog"
        @update:dialog="updateNewTaskDialog"
      />
    </div>
  </v-container>
</template>

<script>
import Input from "@/components/crm/assets/Input.vue";
import SearchIcon from "@/assets/images/icons/search.svg";
import AdvancedFilter from "@/components/crm/assets/advancedFilter.vue";
import GroupBy from "@/components/crm/accounts/GroupBy.vue";
// dialogs
import NewContact from "@/components/crm/assets/forms/create/NewContact.vue";
import NewAccount from "@/components/crm/assets/forms/create/NewAccount.vue";
import NewProject from "@/components/crm/assets/forms/create/NewProject.vue";
import NewEvent from "@/components/crm/assets/forms/create/NewEvent.vue";
import NewDeal from "@/components/crm/assets/forms/create/NewDeal.vue";
import NewTask from "@/components/crm/assets/forms/create/NewTask.vue";

import AssignToAccount from "@/components/crm/assets/AssignToAccount.vue";

import { loginForm } from "@/store/logIn";

export default {
  name: "LeadsManagementFilter",
  props: {
    selected_rows: Array,
    menu: Array,
    assign_to_account_menu: Boolean,
    parent: String,
    dashboard_path_name: String,
    store: Object,
  },

  components: {
    Input,
    AdvancedFilter,
    GroupBy,
    NewAccount,
    AssignToAccount,
    NewProject,
    NewEvent,
    NewDeal,
    NewTask,
    NewContact,
  },

  data() {
    return {
      search: "",
      SearchIcon: SearchIcon,
      NewAccountDialog: false,
      AssignToAccountDialog: false,
      NewProjectDialog: false,
      NewContactDialog: false,
      NewEventDialog: false,
      NewDealDialog: false,
      NewTaskDialog: false,
      filters: [],
      loginStore: loginForm(),
    };
  },

  methods: {
    updateAccountDialog(value) {
      this.NewAccountDialog = value;
    },
    assignToAccount(item) {
      if (item === "Assign To New Account") {
        this.NewAccountDialog = true;
      } else if (item === "Assign To Existed Account") {
        this.AssignToAccountDialog = true;
      }
    },
    updateAssignToAccountDialog(value) {
      this.AssignToAccountDialog = value;
    },
    updateNewProjectDialog(value) {
      this.NewProjectDialog = value;
    },
    updateContactDialog(value) {
      this.NewContactDialog = value;
    },

    updateNewEventDialog(value) {
      this.NewEventDialog = value;
    },
    updateNewDealDialog(value) {
      this.NewDealDialog = value;
    },
    updateNewTaskDialog(value) {
      this.NewTaskDialog = value;
    },
    createItem(item) {
      if (item === "Project") {
        this.NewProjectDialog = true;
      }
      if (item === "Event") {
        this.NewEventDialog = true;
      }
      if (item === "Deals") {
        this.NewDealDialog = true;
      }
      if (item === "Task") {
        this.NewTaskDialog = true;
      }
    },
    showHiddenColumn(key) {
      const header = this.store.headers.find((h) => h.key === key);
      if (header) {
        header.show = true;
      }
    },
    OpenNewDialog(parent) {
      if (parent === "contacts") {
        this.NewContactDialog = true;
      }
      if (parent === "accounts") {
        this.NewAccountDialog = true;
      }
      if (parent === "projects") {
        this.NewProjectDialog = true;
      }
      if (parent === "events") {
        this.NewEventDialog = true;
      }
      if (parent === "deals") {
        this.NewDealDialog = true;
      }
      if (parent === "tasks") {
        this.NewTaskDialog = true;
      }
    },
    handleInput() {
      this.$emit("update:search", this.search);
    },
    getAllFilters() {
      if (this.parent === "contacts") {
        apiClient.get(`/leads-managment/get-attributes`).then((response) => {
          this.filters = response.data.data;
        });
      }
    },

    handleClickPermission() {
      if (!this.hasWritePermission) return;
    },

    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
  },

  computed: {
    accounts() {
      return this.store.accounts;
    },
    hidden_headers() {
      const headers = this.store.headers.filter((header) => !header.show);
      return headers;
    },
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
  },
};
</script>
<style scoped>
.create-list .v-list-item {
  width: 100%;
  max-width: 232px;
  height: 32px;
  padding: 4px 8px;
  border-radius: 4px;
  background: #fafafa;
  margin-bottom: 5px;
}
.create-list .v-list-item:hover {
  background: #eeeeee;
}
@media (max-width: 600px) {
  .dashoard-btn {
    font-size: 12px;
    padding: 4px 8px;
  }
}
.disabled-module {
  pointer-events: none;
  opacity: 0.5;
}
</style>
